import _ from 'lodash'
import ResizeMixin from './ResizeMixin'
import ResizeBarMixin from './ResizeBarMixin'

export default {
  name: 'KFooter',
  mixins: [ResizeBarMixin, ResizeMixin],
  props: {
    height: {
      type: String,
      default: '40px',
    },
  },
  data() {
    return {
      resizeBarPlacement: 'top',
    }
  },
  computed: {},
  watch: {},
  methods: {},
  render() {
    const style = _.assign({
      height: this.height,
    }, this.resizeStyle)

    const css = {
      'km-footer': true,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <footer {...data}>
        {this.$slots.default}
        {this.renderResizeBar()}
      </footer>
    )
  },
}
